import {
  Avatar,
  Box,
  ListItemButton,
  ListItemIcon,
  Tooltip,
} from "@mui/material";
import React, { ReactElement, MouseEvent } from "react";
import { useUser } from "@/app/providers";
import { nameInitial } from "@/utils";

interface UserBoxLinkProps {
  onClick?: (MouseEvent: MouseEvent<HTMLDivElement>) => void;
}

/**
 * UserBoxLink component displays user profile information in a button.
 */
export const UserBoxLink = (props: UserBoxLinkProps): ReactElement => {
  const { user } = useUser();
  const { profilePhotoUrl } = user || {};

  const handleClick = (event: MouseEvent<HTMLDivElement>): void => {
    if (typeof props.onClick === "function") {
      props.onClick(event);
    }
    // if (typeof props.onClick === "function") {
    //   props.onClick(event);
    // }
  };

  // safe display strings
  const displayName = user?.name || user?.email || "";

  return (
    <Box>
      <Tooltip title="Account settings">
        <ListItemButton onClick={handleClick}>
          <ListItemIcon>
            <Avatar alt={displayName} src={profilePhotoUrl}>
              {nameInitial(displayName)}
            </Avatar>
          </ListItemIcon>

          {/* <div className="d-flex flex-column mx-2 text-left">
            <Typography
              variant="h5"
              sx={{
                textAlign: "center",
                lineHeight: 1,
              }}
            >
              {displayName || emailPrefix}
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{
                textAlign: "center",
                lineHeight: 1,
              }}
            >
              {role}
            </Typography>
          </div> */}
        </ListItemButton>
      </Tooltip>
    </Box>
  );
};
